import axios from 'axios'
import React from 'react'
import './inquiry-database.css'
import { baseUrl } from '../assets/Animations'

const InquiryDatabase = () => {
    const [inquiries, setInquiries] = React.useState([])
    const [showComment, setShowComment] = React.useState(false)
    const [deletePopup, setDeletePopup] = React.useState(false)

    let myToken = localStorage.getItem('token')
    let myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        axios.get(`${baseUrl}/inquiries`, myHeader)
        .then((res) => setInquiries(res.data))
        .catch((err) => console.log(err))
    }, [])

    const deleteInquiry = (id) => {
        axios.delete(`${baseUrl}/inquiries/${id}`, myHeader)
        .then((res) => {
            setInquiries(inquiries.filter(inq => inq.id !== res.data.id))
            setDeletePopup(false)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    return(
        <div className='inquiry-database'>
            {showComment && 
                <div className='inquiry-database__show-comment-bubble'>
                    <p><strong>Question:</strong> {showComment}</p>
                </div>
            }
            {deletePopup &&
                <div className='inquiry-database__delete-popup__wrapper'>
                    <div className='inquiry-database__delete-popup'>
                        <div className='inquiry-database__delete-popup__x__wrapper' >
                            <div className='inquiry-database__delete-popup__x' onClick={() => setDeletePopup(false)}>x</div>
                        </div>
                        <div>Are you sure you want to delete this inquiry?</div>
                        <div className='inquiry-database__delete-btn' onClick={() => setDeletePopup(false)}>cancel</div>
                        <div className='inquiry-database__delete-btn' onClick={() => deleteInquiry(deletePopup)}>Delete</div>
                    </div>
                </div>
            }
           {inquiries.map((inq) => (
            <div className='inquiry-database__row' onMouseEnter={() => setShowComment(inq.note)} onMouseLeave={() => setShowComment(false)}>
                <div className='inquiry-database__item'>{inq.name}</div>
                <div className='inquiry-database__item'>{inq.email}</div>
                <div className='inquiry-database__item'>{inq.phoneNumber}</div>
                <div className='inquiry-database__item'>{inq.school}</div>
                <div className='inquiry-database__item'>{`${new Date(inq.date).getMonth() + 1}/${new Date(inq.date).getDate()}/${new Date(inq.date).getFullYear()}`}</div>
                <div className='inquiry-database__item'>{inq.town}</div>
                <div className='inquiry-database__item__delete_x' onClick={() => setDeletePopup(inq.id)}>x</div>
            </div>
           ))}
        </div>
    )
}
export default InquiryDatabase